class indexCtrl {
    constructor($scope, httpRequest) {
        // $(() => {
        $('body').addClass('leftnav-close')
        // })
        httpRequest.post_queryReportUrl(507).then((res) => {
            if (res.data.success) {
                $scope.url = res.data.value.url
                console.log($scope.url)
            }
        })
    }
}

indexCtrl.$inject = ['$scope', 'httpRequest']
export default indexCtrl



// WEBPACK FOOTER //
// ./src/app/index/indexCtrl.js